import { FoaPart, Regulation } from "../../autogen/bff-api";
import { isAnnouncedPartI } from "./foaPartDisplay";
import { addOsloDays } from "./osloDays";

export const PART_II_SHORT_DEADLINE_DAYS = 3;

export const isFoaPartII = (regulation: Regulation | null | undefined, foaPart: FoaPart | null | undefined): boolean =>
  (regulation ?? Regulation.Foa) === Regulation.Foa && foaPart === FoaPart.PartIi;

// Mirrors ProcedureType.allowsTenderCompetition in the BFF: FOA § 30-1 (1) leaves Part IV's procedure to the buyer.
export const isFoaPartIV = (regulation: Regulation | null | undefined, foaPart: FoaPart | null | undefined): boolean =>
  (regulation ?? Regulation.Foa) === Regulation.Foa && foaPart === FoaPart.PartIv;

export const allowsTenderCompetition = (
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
): boolean => isFoaPartII(regulation, foaPart) || isFoaPartIV(regulation, foaPart);

export const isFoaPartIII = (regulation: Regulation | null | undefined, foaPart: FoaPart | null | undefined): boolean =>
  (regulation ?? Regulation.Foa) === Regulation.Foa && foaPart === FoaPart.PartIii;

export const isUtilitiesPartII = (
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
): boolean => regulation === Regulation.Forsyningsforskriften && foaPart === FoaPart.PartIi;

export const isUtilitiesPartIII = (
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
): boolean => regulation === Regulation.Forsyningsforskriften && foaPart === FoaPart.PartIii;

export const buyerChoosesEspd = (
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
): boolean => isFoaPartII(regulation, foaPart) || isFoaPartIV(regulation, foaPart) || isUtilitiesPartIII(regulation, foaPart);

export const usesEspd = (context: {
  regulation?: Regulation | null;
  foaPart?: FoaPart | null;
  espdEnabled?: boolean | null;
  announcedOnDoffin?: boolean | null;
}): boolean =>
  !isAnnouncedPartI(context) &&
  (!buyerChoosesEspd(context.regulation, context.foaPart) || context.espdEnabled !== false);

export const isShortPartIIDeadline = (
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
  deadlineIso: string | null | undefined,
  announcedAt: number = Date.now(),
): boolean =>
  isFoaPartII(regulation, foaPart) &&
  deadlineIso != null &&
  Date.parse(deadlineIso) < Date.parse(addOsloDays(announcedAt, PART_II_SHORT_DEADLINE_DAYS));

export const isPartIIDeadlineNotAfterAnnouncement = (
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
  deadlineIso: string | null | undefined,
  announcedAt: number = Date.now(),
): boolean =>
  isFoaPartII(regulation, foaPart) && deadlineIso != null && new Date(deadlineIso).getTime() <= announcedAt;
